<style lang="scss" scoped>
.dropdown-item {
  &[disabled] {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &[disabled] {
      cursor: not-allowed;
    }
  }
}
</style>

<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div
          class="dropdown-item"
          @click="changeActive"
          :disabled="changingActivation || deleting"
        >
          {{ activeText }}
        </div>
        <div class="dropdown-item" @click="edit" :disabled="deleting">
          Bearbeiten
        </div>
        <div class="dropdown-item" @click="remove" :disabled="deleting">
          Löschen
        </div>
      </div>
    </div>
  </td>
</template>

<script lang="babel">
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
    props: ['content', 'label', 'model'],
    data() {
      return {
        show: false,
        changingActivation: false,
        deleting: false
      };
    },
    computed: {
      activeText() {
        return this.model.active ? 'Deaktivieren' : 'Aktivieren';
      }
    },
    mounted() {
      catchOutsideClicks(this.$refs.dropdown, () => {
        this.show = false;
      });
    },
    methods: {
      edit() {
        if (this.removing) {
          return;
        }

        this.$router.push({ path: new URL(this.model.update_page_url).pathname });
      },
      remove() {
        if (this.removing) {
          return;
        }

        let confirmed = confirm('Sicher?');
        if (!confirmed) {
          return;
        }

        this.removing = true;

        this.$store.dispatch('coupon/delete', { url: this.model.delete_url, id: this.model.id}).then(() => {
          this.$emit('table-update', { count: true });
        }).finally(() => {
          this.removing = false;
        });
      },
      changeActive() {
        if (this.changingActivation || this.removing) {
          return;
        }

        this.changingActivation = true;

        const data = {};
        data["active"] = !this.model.active;
        data["amount"] = this.model.amount;
        data["start"] = this.model.start;
        data["end"] = this.model.end;
        data["slug"] = this.model.slug;
        data["for_one"] = this.model.for_one;
        data["_method"] = "patch";

        this.$store.dispatch('coupon/update', { url: this.model.update_url, data: data }).then(() => {
          this.$emit('table-update');
        }).finally(() => {
          this.changingActivation = false;
        });
      }
    }
};
</script>
